module.exports = __webpack_public_path__ + "afb79da2f3c4846e923365ac994fe4c3.epic.png";


//////////////////
// WEBPACK FOOTER
// ./components/productVariants/rankPickers/mobileLegends/assets/epic.png
// module id = 1H5J
// module chunks = 0